import { useCallback, createRoot } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';

const INVALIDBLOCKS = false;
const RECOVERED = false;

const recoverBlock = ({ name, attributes, innerBlocks }) =>
  wp.blocks.createBlock(name, attributes, innerBlocks);

const recoverBlocks = (blocks) => {
  return blocks.map((_block) => {
    const block = _block;
    // reset
    block.validationIssues = [];
    block.isValid = true;
    // If the block is a reusable block, recover the blockbite blocks inside it.
    if (block.innerBlocks && block.innerBlocks.length) {
      const newInnerBlocks = recoverBlocks(block.innerBlocks);
      block.innerBlocks = newInnerBlocks;
      block.replacedClientId = block.clientId;
      // check for attribute biteId and remove it
      if (block.attributes.biteId) {
        delete block.attributes.biteId;
      }
    }

    const newBlock = recoverBlock(block);
    newBlock.replacedClientId = block.clientId;
    // check for attribute biteId and remove it
    if (newBlock.attributes.biteId) {
      delete newBlock.attributes.biteId;
    }
    return newBlock;

    return block;
  });
};
const recoverAllBlocks = () => {
  // Recover all the blocks that we can find.
  var mainBlocks = wp.data.select('core/editor').getEditorBlocks();
  const blocks = recoverBlocks(mainBlocks);
  // Get the current post ID.
  const postId = wp.data.select('core/editor').getCurrentPostId();

  // Update the post content with the recovered blocks.

  wp.data
    .dispatch('core/editor')
    .editPost({ content: wp.blocks.serialize(blocks) }, postId);

  // refresh the editor
  wp.data.dispatch('core/editor').resetBlocks(blocks);
};

const RecoverCheck = () => {
  const _blocks = wp.data.select('core/editor').getEditorBlocks();

  const recursivelyRecoverBlocks = (willRecoverBlocks) => {
    willRecoverBlocks.forEach((_block) => {
      const newBlock = recoverBlock(_block);
      for (const key in newBlock) {
        _block[key] = newBlock[key];
      }
      if (_block.innerBlocks.length) {
        recursivelyRecoverBlocks(_block.innerBlocks);
      }
    });
  };
  recursivelyRecoverBlocks(_blocks);
  recoverAllBlocks();
};

export { RecoverCheck };
